import { AccountBalanceOutlined, BusinessOutlined, SchoolOutlined } from "@mui/icons-material";
import { type SvgIconProps } from "@mui/material";

export type AdminOrganizationKind = "District" | "Organization" | "School";

export function adminOrganizationKindFromPageType(
  pageType: "district" | "organization" | "school",
): AdminOrganizationKind {
  if (pageType === "district") {
    return "District";
  }
  if (pageType === "organization") {
    return "Organization";
  }
  return "School";
}

export function adminOrganizationKindChipColor(kind: AdminOrganizationKind) {
  if (kind === "District") {
    return "primary" as const;
  }
  if (kind === "School") {
    return "secondary" as const;
  }
  return "info" as const;
}

export function adminOrganizationKindFromOrganizationType(organizationType?: string | null): AdminOrganizationKind {
  if (organizationType === "SchoolDistrict") {
    return "District";
  }
  if (organizationType === "School") {
    return "School";
  }
  return "Organization";
}

export function adminOrganizationKindLabel(kind: AdminOrganizationKind): string {
  if (kind === "District") {
    return "School district";
  }
  if (kind === "Organization") {
    return "Organization";
  }
  return "School";
}

export function AdminOrganizationKindIcon({ kind, ...props }: { kind: AdminOrganizationKind } & SvgIconProps) {
  if (kind === "District") {
    return <AccountBalanceOutlined color="primary" {...props} />;
  }
  if (kind === "Organization") {
    return <BusinessOutlined color="info" {...props} />;
  }
  return <SchoolOutlined color="secondary" {...props} />;
}
